import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LandingPage } from './pages/landing';
import { Dashboard } from './pages/Dashboard';
import { Positions } from './pages/Positions';
import { Transactions } from './pages/Transactions';
import { Clients } from './pages/Clients';
import { Contracts } from './pages/Contracts';
import { Alerts } from './pages/Alerts';
import { Import } from './pages/Import';

function App() {
  return (
    <Routes>
      {/* Marketing Landing Page */}
      <Route path="/" element={<LandingPage />} />

      {/* Authenticated App Routes */}
      <Route path="/app" element={<Layout />}>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="positions" element={<Positions />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="clients" element={<Clients />} />
        <Route path="contracts" element={<Contracts />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="import" element={<Import />} />
      </Route>

      {/* Redirect old routes to new /app/* paths */}
      <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
      <Route path="/positions" element={<Navigate to="/app/positions" replace />} />
      <Route path="/transactions" element={<Navigate to="/app/transactions" replace />} />
      <Route path="/clients" element={<Navigate to="/app/clients" replace />} />
      <Route path="/contracts" element={<Navigate to="/app/contracts" replace />} />
      <Route path="/alerts" element={<Navigate to="/app/alerts" replace />} />
      <Route path="/import" element={<Navigate to="/app/import" replace />} />
    </Routes>
  );
}

export default App;
